import React from 'react';
import DiscordIcon from '../../assets/icons/discord_white.svg';
import EmailIcon from '../../assets/icons/envelop_raw.svg';
import PhoneIcon from '../../assets/icons/phone_white.svg';
import TelegramIcon from '../../assets/icons/telegram_white.svg';
import TwitterIcon from '../../assets/icons/twitter_white.svg';
import WalletIcon from '../../assets/icons/wallet_raw.svg';
import { showSuccessMessage } from '../../components/base/Notifications';
import Tooltip from '../../components/ui/Tooltip';
import uniqueId from '../../utils/uniqueId';
import styles from './Contacts.module.scss';

const getIcon = (type) => {
  switch (type) {
    case 'wallet':
      return <WalletIcon height={14} width={14} color="#90A0B7" />;
    case 'email':
      return <EmailIcon height={14} width={14} color="#90A0B7" />;
    case 'phone':
      return <PhoneIcon height={14} width={14} color="#90A0B7" />;
    case 'twitter':
      return <TwitterIcon height={14} width={14} color="#90A0B7" />;
    case 'telegram':
      return <TelegramIcon height={14} width={14} color="#90A0B7" />;
    case 'discord':
      return <DiscordIcon height={14} width={14} color="#90A0B7" />;
    default:
      return null;
  }
};

const getTooltip = (type) => {
  switch (type) {
    case 'wallet':
      return 'Copy wallet address to clipboard';
    case 'email':
      return 'Copy email address to clipboard';
    case 'phone':
      return 'Copy phone number to clipboard';
    case 'twitter':
      return 'Copy twitter id to clipboard';
    case 'telegram':
      return 'Copy telegram id to clipboard';
    case 'discord':
      return 'Copy discord id to clipboard';
    default:
      return null;
  }
};

const ContactReach = ({ data, type }) => {
  const tooltipId = uniqueId('contact_reach');

  const handleClick = () => {
    navigator.clipboard.writeText(data).then(() => {
      showSuccessMessage(`${type} was copied to your clipboard`);
    });
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        className={styles.reach_button}
        data-for={tooltipId}
        data-tip
      >
        {getIcon(type)}
      </button>
      <Tooltip id={tooltipId} info={getTooltip(type)} />
    </>
  );
};

export default ContactReach;
